import NotificationsIcon from "@mui/icons-material/Notifications";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { Box, Typography } from "@mui/material";
import { IColorTokens } from "../../../../types/theme";

interface LivePreviewPanelProps {
  title: string;
  message: string;
  colors: IColorTokens;
}

// In-app only for now -- Push/Email tabs can come back once those delivery
// methods are managed here too.
export default function LivePreviewPanel({ title, message, colors }: LivePreviewPanelProps) {
  const previewTitle = title.trim() || "Notification Title";
  const previewMessage = message.trim() || "Your message preview will appear here.";
  const truncatedMessage =
    previewMessage.length > 90 ? `${previewMessage.slice(0, 90)}...` : previewMessage;

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="overline" sx={{ letterSpacing: 1, color: colors.primary[300] }}>
          Live Preview
        </Typography>
        <AutoAwesomeIcon sx={{ color: colors.primary[400], fontSize: 20 }} />
      </Box>

      <Box
        sx={{
          borderRadius: 4,
          p: 2.5,
          bgcolor: "#0b0b0b",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography sx={{ color: "#fff", fontSize: "0.85rem" }}>9:41</Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.6)", fontSize: "0.8rem" }}>Now</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 1.5,
            bgcolor: "#fff",
            borderRadius: 3,
            p: 2,
          }}
        >
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              bgcolor: colors.primary[700],
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <NotificationsIcon fontSize="small" />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}>
              <Typography sx={{ fontSize: "0.8rem", color: "#666", fontWeight: 600 }}>
                MMS
              </Typography>
              <Typography sx={{ fontSize: "0.75rem", color: "#999" }}>now</Typography>
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#111" }}>
              {previewTitle}
            </Typography>
            <Typography sx={{ fontSize: "0.85rem", color: "#555" }}>
              {truncatedMessage}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
